import { useMutation, useQuery } from 'react-query';
import axios from 'axios';

export const getRecommendedProducts = async ({ queryKey }) => {
  const [_key, { productId }] = queryKey;
  let data = await fetch(`${window.location.origin}/recommendations/products.json?product_id=${productId}&limit=6`).then((r) => r.json());
  return data.products;
};
